import React from 'react';
import { MessageCircle } from 'lucide-react';
import { siteConfig } from '../data/mockData';

const WhatsAppButton = () => {
  const whatsappLink = `https://wa.me/${siteConfig.contact.whatsapp}?text=Ciao! Vorrei informazioni sui vostri servizi di personal training.`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 group"
      aria-label="Contattaci su WhatsApp"
    >
      <div className="relative">
        {/* Pulse animation */}
        <div className="absolute inset-0 bg-green-500 rounded-full animate-ping opacity-75"></div>
        
        {/* Button */}
        <div className="relative w-16 h-16 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 rounded-full shadow-lg shadow-green-500/50 flex items-center justify-center transition-all duration-300 hover:scale-110">
          <MessageCircle className="w-8 h-8 text-white" />
        </div>
      </div>
      
      {/* Tooltip */}
      <div className="absolute bottom-full right-0 mb-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        <div className="bg-black/90 backdrop-blur-sm text-white px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap shadow-xl">
          Scrivici su WhatsApp
          <div className="absolute top-full right-6 w-0 h-0 border-l-8 border-r-8 border-t-8 border-transparent border-t-black/90"></div>
        </div>
      </div>
    </a>
  );
};

export default WhatsAppButton;
